import { Button, ButtonProps } from '@mantine/core';
import { IconBook } from '@tabler/icons-react';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

type TravelReferenceDocumentsButtonLinkProps = Pick<ButtonProps, 'visibleFrom' | 'hiddenFrom' | 'fullWidth'>;

export function TravelReferenceDocumentsButtonLink(props: TravelReferenceDocumentsButtonLinkProps) {
  const { t } = useTranslation();

  return (
    <Button
      variant="outline"
      leftSection={<IconBook size={16} />}
      // The polymorphic component prop erases the route's search type, renderRoot keeps it.
      renderRoot={rootProps => (
        <Link
          {...rootProps}
          to="/travel/documents"
          search={{ kind: 'USER_GUIDE' }}
        />
      )}
      {...props}
    >
      {t('travel.referenceDocuments.guideButton')}
    </Button>
  );
}
